import { Component, Optional, Self } from '@angular/core';
import { Observable } from 'rxjs';
import { NgControl } from '@angular/forms';

import { ApplicationsService, IApplication } from '@app/core/applications';

@Component({
  selector: 'app-application-select',
  templateUrl: './application-select.component.html',
})
export class ApplicationSelectComponent {
  public selectedRecord: string;
  public records$: Observable<IApplication[]>;

  public isDisabled: boolean;

  private onChange: (val: any) => any;
  private onTouch: () => any;

  constructor(
    @Self()
    @Optional()
    public control: NgControl,
    private service: ApplicationsService
  ) {
    this.control && (this.control.valueAccessor = this);
    this.records$ = this.service.getApplications();
  }

  public get isInvalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get shouldShowError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;
    return this.isInvalid ? dirty || touched : false;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(input: any): void {
    this.selectedRecord = input;
  }

  public selectedRecordChanged(): void {
    this.onChange(this.selectedRecord);
    this.onTouch();
  }
}
